import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LoadingBar from '../../../common/LoadingBar';
import DocumentsRow from '../../claims/claimsEntries/DocumentsRow';

const ClaimsHistoryEntry = ({ id, claimHistory, onGetDocuments, court_code, case_number, selectedClaim }) => {
  const claimNum =
    parseInt(claimHistory.claim_no, 10) ||
    (claimHistory.claim_no === 'doc' && claimHistory.claim_seq && claimHistory.claim_seq.split('-')[0]);
  const seqNum =
    claimHistory.claim_sequence_number ||
    (claimHistory.claim_no === 'doc' && claimHistory.claim_seq && claimHistory.claim_seq.split('-')[1]);
  const claimNumLabel =
    parseInt(claimHistory.claim_no, 10) && claimHistory.claim_sequence_number
      ? `${claimHistory.claim_no}-${claimHistory.claim_sequence_number}`
      : 'doc';

  const claimNumLink =
    claimNum && seqNum ? (
      <a
        href="#"
        className="docket_no"
        onClick={e => {
          e.preventDefault();
          onGetDocuments(claimNum, seqNum, court_code, case_number);
        }}
      >
        {claimNumLabel}
      </a>
    ) : (
      'doc'
    );

  return (
    <Fragment>
      <tr>
        <td colSpan="2">{claimNumLink}</td>
        <td>
          <span dangerouslySetInnerHTML={{ __html: claimHistory.claim_text }} />
          {claimHistory.status === 'loading' ||
            (selectedClaim.claimNum === claimNum && selectedClaim.status === 'loading' && <LoadingBar overrideShow />)}
        </td>
      </tr>
      {selectedClaim.claimNum === claimNum && selectedClaim.status !== 'loading' && (
        <DocumentsRow
          id={id}
          binder={selectedClaim.binder}
          case_uuid=""
          court_code={court_code}
          case_number={case_number}
          claimNum={claimNum}
          seqNum={seqNum}
        />
      )}
    </Fragment>
  );
};

ClaimsHistoryEntry.propTypes = {
  id: PropTypes.string.isRequired,
  claimHistory: PropTypes.object.isRequired,
  selectedClaim: PropTypes.object.isRequired,
  onGetDocuments: PropTypes.func.isRequired,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
};

export default ClaimsHistoryEntry;



// WEBPACK FOOTER //
// ./src/components/case/claims/claimsEntries/ClaimsHistoryEntry.jsx